import React from "react";
import Footer from "./Footer";
import Header from "./Header";
import Main from "../../../pages/Main";
import "../../styles/style.scss"

const AppLayout = (props) => {
  return (
    <div>
      <Header {...props} signIn={true} buttonTitle="Find Your Best Card" path="/find-best-card-for-your-spend"/>
      <Main/>
      <Footer />
    </div>
  );
};

export default AppLayout;
